import React from 'react'
import DuracionEntrevistaTotal from '../Components/Home/duracion-entrevista-total'
import Navbar from '../Components/Navbar/Navbar'

const DuracionEntrevistaTotalScreen = () => {
    return (
        <section>
            <Navbar />
            <DuracionEntrevistaTotal/>
        </section>
    )
}

export default DuracionEntrevistaTotalScreen
